"use client";

import { Card, Col, Row, Typography } from "antd";
import { Fragment, useEffect } from "react";
import Head from "next/head";
import PDFViewer from "@/components/common/PDFViewer";
import MKTScript from "@/components/MKTScript";

const { Title } = Typography;

const InspectionPolicyPage = () => {
  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <MKTScript />
      <Head>
        <title>Chính sách kiểm hàng | {process.env.NEXT_PUBLIC_PLATFORM_NAME || ""}</title>
        <meta
          name="description"
          content={`Chính sách kiểm hàng của ${process.env.NEXT_PUBLIC_PLATFORM_NAME || ""}`}
        />
      </Head>
      <div className="inspection-policy-container">
        <Row justify="center" style={{ padding: "20px" }}>
          <Col xs={24} sm={22} md={20} lg={18} xl={16}>
            <Card
              variant="borderless"
              style={{
                marginBottom: "2rem",
                boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
              }}
            >
              <Title
                level={1}
                style={{ textAlign: "center", marginBottom: "2rem" }}
              >
                CHÍNH SÁCH KIỂM HÀNG
              </Title>

              <PDFViewer
                file="/static/docs/inspection-policy.pdf"
                title="Chính sách kiểm hàng chi tiết"
                width={800}
                showControls={true}
                showDownload={true}
                className="inspection-policy-pdf"
              />
            </Card>
          </Col>
        </Row>
      </div>

      <style jsx global>{`
        .inspection-policy-container {
          background-color: #f5f5f5;
          min-height: 100vh;
          padding: 2rem 0;
        }

        .inspection-policy-pdf {
          width: 100%;
          max-width: 100%;
        }

        @media (max-width: 768px) {
          .inspection-policy-container {
            padding: 1rem 0;
          }
          
          .inspection-policy-pdf {
            width: 100%;
          }
        }
      `}</style>
    </Fragment>
  );
};

export default InspectionPolicyPage;